// extracted by mini-css-extract-plugin
export default {"tab":"tab--k8IFfnySNSJLfU6opLGp"};